import axios from 'axios';

const apiCompetitorGap = axios.create({
  baseURL: `${process.env.REACT_APP_INSV_API_V6}`
});

apiCompetitorGap.interceptors.request.use(async (config) => {
  const token = localStorage.tolkenINSV;

  if (token)
    config.headers.authorization = `${token}`;

  return config;
});

apiCompetitorGap.interceptors.response.use(
  (response) => {
    return response;
  },

  (err) => Promise.reject(err)
);

export default apiCompetitorGap;